import React, { useState, useMemo, useEffect } from 'react';
import { useDebouncedProp } from '@anton.bobrov/react-hooks';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { useWindowSize } from '../../../../../../utils/hooks/useWindowSize.js';
import '../../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-components';
import '../../../../../common/GradientWrapper/index.js';
import '../../../../../common/Icon/index.js';
import '../../../../../common/LazyImage/index.js';
import '../../../../../common/NumberFormat/index.js';
import { SlideFadeContent } from '../../../../../common/SlideFadeContent/index.js';
import { WithCustomScrollbar } from '../../../../../common/WithCustomScrollbar/index.js';
import '../../../../../form/CheckBox/index.js';
import '../../../../../form/CodeInput/index.js';
import '../../../../../form/CryptoSelect/index.js';
import '../../../../../form/FileUploader/index.js';
import '../../../../../form/FormInput/index.js';
import '../../../../../form/FormSelect/index.js';
import '../../../../../form/PhoneInput/index.js';
import '../../../../../form/RadioButton/index.js';
import '../../../../../form/Select/index.js';
import '../../../../../form/SelectV2/index.js';
import '../../../../../form/SelectV3/index.js';
import '../../../../../form/SelectV4/index.js';
import { SearchInput } from '../../../../../form/Search/Input/index.js';
import '../../../../../form/Search/NoResults/index.js';
import '../../../../../form/Switch/index.js';
import '../../../../../form/DatePickerInput/index.js';
import '../../../Context/index.js';
import '../../../../../ui/accordions/Accordion/index.js';
import '../../../../../ui/accordions/AccordionSelect/index.js';
import '../../../../../ui/badges/Badge/index.js';
import '../../../../../ui/badges/BadgeIcon/index.js';
import '../../../../../ui/badges/Checked/index.js';
import '../../../../../ui/badges/Panel/index.js';
import '../../../../../ui/badges/Status/index.js';
import '../../../../../ui/badges/Tag/index.js';
import '../../../../../ui/buttons/BabyButton/Base.js';
import '../../../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../../../ui/buttons/Button/index.js';
import '../../../../../ui/buttons/CloseButton/index.js';
import '../../../../../ui/buttons/DirectionButton/index.js';
import '../../../../../ui/buttons/GradientButton/index.js';
import { GradientButtonV2 } from '../../../../../ui/buttons/GradientButtonV2/index.js';
import '../../../../../ui/buttons/TabButton/index.js';
import '../../../../../ui/buttons/TabButtonV2/index.js';
import '../../../../../ui/buttons/TimerButton/index.js';
import '../../../../../ui/buttons/TimerButtonV2/index.js';
import '../../../../../ui/buttons/TimerButtonV3/index.js';
import '../../../../../ui/loaders/Loader/index.js';
import '../../../../../ui/loaders/ScreenLoader/index.js';
import '../../../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../../../ui/modals/Modal/Modal.js';
import '../../../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../../../ui/popups/Popper/index.js';
import '../../../../../ui/popups/Popup/BasePopup/index.js';
import '../../../../../ui/popups/Popup/Thumb/index.js';
import '../../../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../../../ui/sliders/EmblaCarousel/index.js';
import '../../../../../ui/tables/Table/index.js';
import '../../../../../ui/tables/Table/TableTd/index.js';
import '../../../../../ui/tabs/Tabs/index.js';
import '../../../../../ui/tabs/TabsV2/index.js';
import '../../../../../ui/texts/CryptoValue/index.js';
import '../../../../../ui/texts/AmountValue/index.js';
import '../../../../../ui/texts/TitleWithCurrency/index.js';
import '../../../../../ui/texts/Text/index.js';
import '../../../../../ui/texts/TextNavigation/index.js';
import '../../../../../ui/texts/MinValue/index.js';
import '../../../../../ui/socials/SocialsList/index.js';
import { RenderExpandedMenu } from '../Menu/RenderExpandedMenu/index.js';
import { RenderCollapsedMenu } from '../Menu/RenderCollapsedMenu/index.js';
import { Logo } from '../Logo/index.js';
import styles from './index.module.scss.js';
import { useLayoutContext } from '../../../Context/utils/useLayoutContext.js';

const AsideMenu = ({
  className,
  style,
  socials = [],
  tabs,
  onLogoClick,
  logo,
  tabsVersion = "v3",
  propsLogo,
  onSearch = () => {
  }
}) => {
  const { isAsideMenuOpen } = useLayoutContext();
  const { windowSize } = useWindowSize();
  const expandedKey = "expanded";
  const collapsedKey = "collapsed";
  const activeKey = isAsideMenuOpen ? expandedKey : collapsedKey;
  const [activeTabCoord, setActiveTabCoord] = useState({
    width: 0,
    left: 0
  });
  const debounceActiveKey = useDebouncedProp(activeKey, 750);
  const isShowElem = useDebouncedProp(isAsideMenuOpen, 750);
  const tabsToRender = useMemo(() => {
    if (!tabs) return [];
    if (tabs.activeIndex >= 0) {
      if (tabs.panels[tabs.activeIndex]) {
        return tabs.panels[tabs.activeIndex];
      }
      return [];
    }
    if (tabs.defaultMenu) {
      return tabs.defaultMenu;
    }
    return [];
  }, [tabs]);
  useEffect(() => {
    setTimeout(() => {
      if (tabsVersion !== "v2") return;
      if (!isAsideMenuOpen) return;
      const findActiveButtonTextComponent = document.querySelector(
        '[data-sidebar-tab="true"][data-tab-active="true"] span'
      );
      if (!findActiveButtonTextComponent) return;
      setActiveTabCoord({
        width: findActiveButtonTextComponent.getBoundingClientRect().width,
        left: findActiveButtonTextComponent.getBoundingClientRect().left - 15
      });
    }, 10);
  }, [tabs, tabsVersion, isAsideMenuOpen]);
  const collapsedTabsList = useMemo(
    () => tabs.tabs.map((item, i) => ({
      kind: "link",
      href: "#",
      name: item.name,
      icon: item.icon,
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        item.onClick(i);
      },
      isActive: tabs.activeIndex === i,
      key: `${item.name}_tab`
    })),
    [tabs]
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, {
        [styles.expanded]: isAsideMenuOpen
      }),
      style: {
        ...style,
        "--bottom-height": socials.length ? "62px" : "0px",
        "--scroll-menu-top": tabs?.tabs.length && isAsideMenuOpen ? "0px" : "0px"
      },
      "data-aside": true
    },
    /* @__PURE__ */ React.createElement(
      WithCustomScrollbar,
      {
        className: cx(styles.scroll),
        updateKey: debounceActiveKey
      },
      /* @__PURE__ */ React.createElement(SlideFadeContent, { activeKey, duration: 750 }, /* @__PURE__ */ React.createElement("div", { className: styles["expanded-wrapper"], "data-key": expandedKey }, /* @__PURE__ */ React.createElement("div", { className: styles.tabs, "data-aside-tabs": true }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles.tabs__list, {
            [styles[tabsVersion]]: !!tabsVersion
          }),
          "data-aside-tabs-list": true
        },
        /* @__PURE__ */ React.createElement("div", { className: cx(styles.tabs__bg) }),
        tabs?.tabs?.map((item, i) => /* @__PURE__ */ React.createElement(
          GradientButtonV2,
          {
            active: tabs.activeIndex === i,
            onClick: () => {
              item.onClick(i);
            },
            name: item.name,
            size: "sm",
            className: cx(styles["gradient-btn"], {
              [styles.active]: tabs.activeIndex === i
            }),
            v2: true
          }
        ))
      )), /* @__PURE__ */ React.createElement(
        Logo,
        {
          text: propsLogo ?? { coin: "", soon: "" },
          className: styles.logo,
          logo,
          onClick: onLogoClick
        }
      ), windowSize.width <= 1024 && /* @__PURE__ */ React.createElement("div", { className: styles["search-wrapper"] }, /* @__PURE__ */ React.createElement(
        SearchInput,
        {
          value: "",
          onChange: onSearch,
          onSubmit: () => {
          },
          inputTheme: "blue",
          placeholder: "Search",
          buttonType: true
        }
      )), tabsToRender.map((item, i) => {
        if (item.key === "tabsList") {
          return /* @__PURE__ */ React.createElement("div", { className: styles.group, key: i }, /* @__PURE__ */ React.createElement(RenderExpandedMenu, { menu: [item.list[0]] }));
        }
        return /* @__PURE__ */ React.createElement("div", { className: styles.group, key: i }, item.name && /* @__PURE__ */ React.createElement("div", { className: styles.group__title }, item.name), /* @__PURE__ */ React.createElement(RenderExpandedMenu, { menu: item.list }));
      })), /* @__PURE__ */ React.createElement("div", { className: styles["collapsed-wrapper"], "data-key": collapsedKey }, /* @__PURE__ */ React.createElement(RenderCollapsedMenu, { menu: collapsedTabsList, noBorder: true }), /* @__PURE__ */ React.createElement(Logo, { className: styles.logo, onClick: onLogoClick, size: "sm" }), tabsToRender.map((item, i) => {
        if (item.key === "tabsList") {
          return /* @__PURE__ */ React.createElement(RenderCollapsedMenu, { key: i, menu: [item.list[0]] });
        }
        return /* @__PURE__ */ React.createElement(RenderCollapsedMenu, { menu: item.list });
      })))
    ),
    !!socials.length && isAsideMenuOpen && isShowElem && /* @__PURE__ */ React.createElement("div", { className: styles.footer }, /* @__PURE__ */ React.createElement("div", { className: styles.socials }, socials.map((item) => /* @__PURE__ */ React.createElement(
      Link,
      {
        className: styles.socials__item,
        to: item.href,
        key: item.href
      },
      typeof item.icon === "string" ? /* @__PURE__ */ React.createElement("img", { src: item.icon, alt: "" }) : item.icon
    ))))
  );
};
AsideMenu.displayName = "Layout.AsideMenu";

export { AsideMenu };
//# sourceMappingURL=index.js.map
